import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { ErrorScreen, ErrorScreenProps } from "@/components/error-screen";
import { PAGE_NOT_FOUND_ERROR } from "./configs";

export const PageNotFoundScreen: FC<ErrorScreenProps> = props => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    if (history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <ErrorScreen
      {...PAGE_NOT_FOUND_ERROR}
      onButtonClick={handleButtonClick}
      {...props}
    />
  );
};
